export default "__VITE_ASSET__DgfI$hv6__"